$(document).ready(function(){
  $( ".carouselBlock script" ).remove();
  
   $('.carouselBlock .shg-box-content').slick({
    infinite: true,
  	slidesToShow: 6,
    speed: 600,
    slidesToScroll: 3,
    responsive: [
    {
      breakpoint: 1280,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4,
        infinite: true
      }
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true
      }
    }
  ]
	});
  
    $('.blog3More').slick({
    infinite: true,
  	slidesToShow: 3,
    speed: 600,
    slidesToScroll: 1,
    responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true
      }
    }
  ]
	});
    
}); 

$(document).ready(function(){
  $('.infoBTNop a').attr('rel', 'modal:open'); 
}); 

